import { connect } from "react-redux";
import ApprovalList from "./approvalList";
import { bindActionCreators } from "redux";
import { getInspectionApprovalList, acceptApproval, rejectApproval } from "services/redux/approvals/salesApprovals/action"
import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  approvalList: state.salesApprovalReducer.insApprovalList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getInspectionApprovalList,
    acceptApproval,
    rejectApproval,
    fetchZones,
  getListFilterData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalList);
